import { render, staticRenderFns } from "./EventAbsenceChips.vue?vue&type=template&id=6480a71c"
import script from "./EventAbsenceChips.vue?vue&type=script&lang=js"
export * from "./EventAbsenceChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports